import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";
import { BRAND } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("preshh_admin_token", data.token);
      toast.success("Welcome back.");
      nav("/admin/dashboard");
    } catch { toast.error("Invalid credentials"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#111] border border-white/10 rounded-3xl p-8 space-y-4">
        <img src={BRAND.logo} alt="Preshh" className="h-8" />
        <h1 className="font-display text-2xl">Admin Sign In</h1>
        <Input data-testid={ADMIN.loginEmail} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-white/5 border-white/10" />
        <Input data-testid={ADMIN.loginPassword} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-white/5 border-white/10" />
        <Button data-testid={ADMIN.loginSubmit} type="submit" disabled={loading} className="w-full bg-[#00B5D8] hover:bg-[#009AB8] text-black font-bold rounded-full py-6">{loading ? "Signing in…" : "Sign in"}</Button>
      </form>
    </div>
  );
}
